import { render } from "./ColorChooser.vue?vue&type=template&id=2f11d1d9&scoped=true"
import script from "./ColorChooser.vue?vue&type=script&lang=js"
export * from "./ColorChooser.vue?vue&type=script&lang=js"

import "./ColorChooser.vue?vue&type=style&index=0&id=2f11d1d9&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f11d1d9"]])

export default __exports__